import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { loadAllPaginatedAllowances } from '../../../../slice/payroll/thunks'
import AllowancesTable from './utilities/AllowancesTable'
import { useTranslation, withTranslation } from 'react-i18next'
import GlobalLoader from '../../../../components/Common/GlobalLoader'
import { Link } from 'react-router-dom'
import BreadCrumb from '../../../../components/Common/BreadCrumb'
import withRouter from '../../../../components/Common/withRouter'

 function Allowance() {
  const dispatch = useDispatch()
  const { allowances, isAllowancesLoading } = useSelector(state => state.Payroll)


  useEffect(() => {
    dispatch(loadAllPaginatedAllowances({ page: 1, limit: 10 }))
  }, [dispatch])
  return (
    <div className="container-fluid">
      {isAllowancesLoading ? <GlobalLoader /> : <>
        <div className="patients-list py-4 px-2  ">
          <div className="row list-patients d-flex  justify-content-between">
            <Link to="/payroll/setting" className="col-lg-5">
              <BreadCrumb title={"payroll_settings"} pageTitle={"Allowances"} />
            </Link>
            <div className="col-sm-auto new-mode-btn">
              <Link to="/payroll/setting/allowances/create" className="btn btn-std mx-2" >
                <i className="fas fa-user-md mx-1"></i>
                {"create_new"}
              </Link>
            </div>
          </div>
          <div className="payment-mode-lists">
            <div className="container-fluid">
              <div className="row justify-content-between">
                <div className="row justify-content-between">
                  <AllowancesTable data={allowances} />
                </div>
              </div>
            </div>
          </div>




        </div>
      </>}
    </div>
  )
}

export default withTranslation()(withRouter(Allowance))
